var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.4691C16.4733 11.2232 18.0003 9.53989 18.0003 7.49998C18.0003 5.46006 16.4733 3.77679 14.5 3.53088C15.4337 4.58863 16.0003 5.97814 16.0003 7.49998C16.0003 9.02182 15.4337 10.4113 14.5 11.4691Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5C20 21.0523 20.4477 21.5 21 21.5C21.5523 21.5 22 21.0523 22 20.5V18.5C22 15.8399 19.9227 13.665 17.3018 13.509C18.3539 14.4407 19.1587 15.6454 19.6055 17.012C19.8565 17.4505 20 17.9585 20 18.5V20.5Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15.5C5.34315 15.5 4 16.8431 4 18.5V20.5C4 21.0523 3.55228 21.5 3 21.5C2.44772 21.5 2 21.0523 2 20.5V18.5C2 15.7386 4.23858 13.5 7 13.5H13C15.7614 13.5 18 15.7386 18 18.5V20.5C18 21.0523 17.5523 21.5 17 21.5C16.4477 21.5 16 21.0523 16 20.5V18.5C16 16.8431 14.6569 15.5 13 15.5H7Z",
    fill: "#6F767E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.5C8.89543 5.5 8 6.39543 8 7.5C8 8.60457 8.89543 9.5 10 9.5C11.1046 9.5 12 8.60457 12 7.5C12 6.39543 11.1046 5.5 10 5.5ZM6 7.5C6 5.29086 7.79086 3.5 10 3.5C12.2091 3.5 14 5.29086 14 7.5C14 9.70914 12.2091 11.5 10 11.5C7.79086 11.5 6 9.70914 6 7.5Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.581ea06e8e39d93f06f0f06d9169c983.svg";
export { ForwardRef as ReactComponent };